import {TableHead, TableRow, Typography} from '@mui/material';
import styled, {css} from 'styled-components';

const StyledTableHead = styled(TableHead)`
	${({theme}) => css`
		background-color: ${theme.colors.gray['10Percent']};
	`}
`;

const StyledTableRow = styled(TableRow)`
	& > th {
		padding: 8px 0;
	}
`;

const StyledTypographyHead = styled(Typography)`
	font-size: 0.75rem;
	font-weight: 600;
	color: ${({theme}) => theme.colors.light.text.secondary};
	text-transform: uppercase;

	padding: 0px 16px;
`;

export {StyledTableHead, StyledTableRow, StyledTypographyHead};
